import { FormTextField } from '@map/components/formControls/controlled';
import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import { useFormatMessage } from '@shared/hooks/intl';
import { useIsSubmitting } from '@shared/lib/form/Form';
import Button from '@ui/Button';
import { FormattedMessage } from 'react-intl';
import PublicPage from '../shared/PublicPage';

const useStyles = makeStyles(({ spacing }) => ({
  username: {
    marginTop: spacing(8),
    marginBottom: spacing(6),
  },
}));

const ForgotPasswordForm = () => {
  const { classes } = useStyles();
  const t = useFormatMessage();
  const isSubmitting = useIsSubmitting();

  return (
    <PublicPage title={<FormattedMessage id="forgot_password.title" />}>
      <Typography variant="body2" align="center">
        <FormattedMessage id="forgot_password.text" />
      </Typography>
      <div className={classes.username}>
        <FormTextField name="username" margin="none" placeholder={t('login.username_label')} />
      </div>
      <Button fullWidth={true} type="submit" color="primary" size="medium" disabled={isSubmitting}>
        <FormattedMessage id="forgot_password.subtitle" />
      </Button>
    </PublicPage>
  );
};

export default ForgotPasswordForm;
